__turbopack_context__.v({
  "max-width": "m-animated-illustration-module-scss-module__8rXRGW__max-width",
  "placeholder": "m-animated-illustration-module-scss-module__8rXRGW__placeholder",
  "svg": "m-animated-illustration-module-scss-module__8rXRGW__svg",
});
